import { roles } from "../config/config";

export const summariesPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
  roles.contabile,
];

export const summaryItemPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
];

export const summaryServicesPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
  roles.contabile,
];

export const getSummariesPermissions = (userIsAgente) => [
  ...summariesPermissions,
  userIsAgente,
];

export const getSummaryItemPermissions = (userIsAgente) => [
  ...summaryItemPermissions,
  userIsAgente,
];

export const getSummaryServicesPermissions = (userIsAgente) => [
  ...summaryServicesPermissions,
  userIsAgente,
];
